export default class SharedState {
  constructor() {
    // CREATE
    this.uploadFile = {
      loading: {},
      data: {},
      error: {},
    };
    this.uploadMultipleFile = {
      loading: {},
      data: {},
      error: {},
    };
  }
}
